<template>
  <ModalPlay
    size="xs"
    icon="warning"
    icon-color="var(--feedback-error-500)"
    :title="$t('delete_comment_modal.title')"
    @close="emit('close')"
  >
    <template #footer>
      <ButtonPlayV2
        variant="ghost"
        :text="$t('simple_feedback.default_cancel_btn')"
        @click="emit('close')"
      />
      <ButtonPlayV2
        variant="filled"
        icon="delete"
        color="var(--feedback-error-500)"
        :text="$t('delete_comment_modal.confirm_btn')"
        @click="handleDeleteComment"
      />
    </template>
  </ModalPlay>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { toast } from '@/events'
import { ModalPlay } from '@/components/atomic'
import { useWatchStore } from '@/store/watch.store'

const props = defineProps<{
  item: string | number
  courseId?: string | number
  moduleId?: string | number
  lessonId?: string | number
}>()

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()
const watchStore = useWatchStore()

async function handleDeleteComment() {
  try {
    await watchStore.doCommentDelete({
      id: props.item,
      courseId: props.courseId,
      moduleId: props.moduleId,
      lessonId: props.lessonId,
    })

    toast.success(t('delete_comment_modal.sucess_toast_desc'), t('delete_comment_modal.sucess_toast_title'))
    emit('close')
  } catch (_error) {
    toast.error(t('delete_comment_modal.error_toast_desc'), t('delete_comment_modal.error_toast_title'))
  }
}
</script>

<style lang="scss" scoped>
</style>
